// store/vesselsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const summarySlice = createSlice({
  name: "summary",
  initialState: {
    data: {},
    loading: false,
    error: null,
  },
  reducers: {
    setSummary(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearSummary(state) {
      state.data = [];
    },
  },
});

export const { setSummary, setLoading, setError, clearSummary } =
  summarySlice.actions;

export default summarySlice.reducer;
